<template>
  <div class="main-content bg-default min-vh-100">
    <!-- Navbar -->
    <base-nav class="navbar-top navbar-horizontal navbar-dark"
              containerClasses="px-4 container"
              expand>
      <router-link slot="brand" class="navbar-brand" to="/">
        <img src="img/brand/white.png"/>
      </router-link>

      <template v-slot="{closeMenu}">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="img/brand/green.png">
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button type="button"
                      @click="closeMenu"
                      class="navbar-toggler"
                      aria-label="Toggle sidenav">
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </base-nav>
    <!-- Header -->
    <div class="header bg-gradient-info py-7 py-lg-8">
      <div class="container">
          <div class="header-body text-center mb-7">
              <div class="row justify-content-center">
                  <div class="col-lg-5 col-md-6">
                      <h1 class="text-white">Cari Hesap v1!</h1>
                      <p class="text-lead text-white">Gelir gider takibinizi, kullanıcı deneyimi en yüksek uygulama ile yapın.</p>
                  </div>
              </div>
          </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>E-mail ve şifrenizle giriş yapın</small>
              </div>
              <form role="form" @submit.prevent="loginAction">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Ad Soyad"
                  addon-left-icon="ni ni-circle-08"
                  v-model="model.full_name">
                </base-input>

                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                  v-model="model.email">
                </base-input>

                <div class="form-group input-group-alternative mb-3 input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="ni ni-chat-round"></i>
                    </span>
                  </div>
                  <input aria-describedby="addon-right addon-left" v-model="model.phone" v-mask="'+90 (###) ### ## ##'" placeholder="Cep Telefonu (aktivasyon kodu gönderilecek)" class="form-control">
                </div>

                <base-input
                  class="input-group-alternative"
                  placeholder="Şifre"
                  type="password"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="model.password">
                </base-input>

                <base-input
                  class="input-group-alternative"
                  placeholder="Şifre tekrar"
                  type="password"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="model.password_confirmation">
                </base-input>
                <div class="text-center">
                  <b-button variant="primary" class="loading-button mt-4" type="submit">
                    <i v-if="loading" class="fa fa-spinner"></i> Kayıt Ol
                    </b-button>
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6"></div>
            <div class="col-6 text-right">
              <router-link to="/giris-yap" class="text-light"><small>Hesabınız var mı?</small></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="py-5">
      <div class="container">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-muted">
              &copy; {{ year }} <a href="https://www.creative-tim.com" class="font-weight-bold ml-1"
                                 target="_blank">Core Interactive</a>
            </div>
          </div>
          <div class="col-xl-6">
            <ul class="nav nav-footer justify-content-center justify-content-xl-end">
              <li class="nav-item">
                <a href="/" class="nav-link" target="_blank">E-cari Hesap</a>
              </li>
              <li class="nav-item">
                <a href="https://ecarihesap.com/hakkimizda" class="nav-link" target="_blank">Hakkımızda</a>
              </li>
              <li class="nav-item">
                <a href="https://ecarihesap.com/iletisim" class="nav-link" target="_blank">İletişim</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'Register',
    data() {
      return {
        loading: false,
        year: (new Date()).getFullYear(),
        showMenu: false,
        model: {}
      }
    },
    methods: {
      ...mapActions(['register']),
      loginAction () {
        this.loading = true;
        this.register(this.model).then(() => {
          this.loading = false;
          window.location.href = "/"
        }).catch(error => {
          this.loading = false;
          this.error(error.response.data.message)
        })
      }
    }
  }
</script>
